var Control             = require("enyo/Control"),
    EventEmitterSupport = require("enyo-ui/EventEmitterSupport"),
    FadeSupport         = require("enyo-ui/FadeSupport"),
    FloatingSupport     = require("enyo-ui/FloatingSupport"),
    kind                = require("enyo/kind");

require("enyo-ui");

/**
 * Fires when the Scrim is absoluteShowing, not fading and fully faded in.
 *
 * @event     enyo-ui.Scrim#revealed
 * @type      {object}
 * @property  {enyo.Control}  sender  The popup that emitted the event
 */

/**
 * Fires when the Scrim is not absoluteShowing, not fading and fully faded out.
 *
 * @event     enyo-ui.Scrim#hidden
 * @type      {object}
 * @property  {enyo.Control}  sender  The popup that emitted the event
 */

/**
 * [Scrim]{@link enyo-ui.Scrim} is a simple overlay with a fade-in and fade-out
 * animation.
 *
 * @ui
 * @class   enyo-ui.Scrim
 * @extends enyo.Control
 * @mixes   enyo-ui.EventEmitterSupport
 * @mixes   enyo-ui.FadeSupport
 * @mixes   enyo-ui.FloatingSupport
 * @public
 */
module.exports = kind(/** @lends  enyo-ui.Scrim.prototype */ {

    /**
     * @private
     */
    name: "enyo-ui.Scrim",

    /**
     * @private
     */
    kind: Control,

    /**
     * @private
     */
    mixins: [
        EventEmitterSupport,
        FadeSupport,
        FloatingSupport
    ],

    /**
     * @private
     */
    classes: "enyo-ui-scrim enyo-fit",

    /**
     * @public
     */
    showing: false,

    /**
     * @public
     */
    initialOpacity: 0,

    /**
     * @private
     */
    handlers: {
        onRequestShow: "requestShow",
        onRequestHide: "requestHide"
    },

    /**
     * @private
     */
    observers: {
        emitShowingEvents: ["absoluteShowing", "fading"]
    },

    /**
     * Emits `revealed` event when popup is absoluteShowing and no longer fading.
     * Emits `hidden` event when popup is not absoluteShowing and no longer
     * fading.
     *
     * @fires  enyo-ui.Scrim#revealed
     * @fires  enyo-ui.Scrim#hidden
     * @param  {*}  was  The previous value
     * @param  {*}  is   The current value
     * @private
     */
    emitShowingEvents: function(was, is) {
        if (was !== is && !this.fading && this.absoluteShowing && this.isFadedIn()) {
            this.emit("revealed", {
                sender: this
            });
        }
        else if (was !== is && !this.fading && !this.absoluteShowing && this.isFadedOut()) {
            this.emit("hidden", {
                sender: this
            });
        }
    },

    /**
     * Reveals the popup by rendering it if needed and then fading in.
     *
     * @param  {boolean=}  fade  `true` if scrim should fade, `false`
     *                           otherwise
     * @param  {boolean=}  snap  `true` if fade should be instant, `false`
     *                           otherwise
     * @return {boolean}   Stop propagation.
     * @public
     */
    requestShow: function(fade, snap) {
        !this.hasNode() && this.render();
        this.show(fade, snap);

        return true;
    },

    /**
     * Hides the popup by fading it out if needed.
     *
     * @param  {boolean=}  fade  `true` if scrim should fade, `false`
     *                           otherwise
     * @param  {boolean=}  snap  `true` if fade should be instant, `false`
     *                           otherwise
     * @return {boolean}   Stop propagation.
     * @public
     */
    requestHide: function(fade, snap) {
        this.hide(fade, snap);

        return true;
    }

});
